import { render, staticRenderFns } from "./ColaboradorUsers.vue?vue&type=template&id=5c5810ac&scoped=true"
import script from "./ColaboradorUsers.vue?vue&type=script&lang=js"
export * from "./ColaboradorUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5810ac",
  null
  
)

export default component.exports